import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../../services/AnalyticsService';
import { IInvoicePaymentModalStore } from '../../../stores/InvoicePaymentModalStore';
import { ITranslateStore } from '../../../stores/TranslateStore';

import PaymentModal from './PaymentModal';

interface IInvoicePaymentModalProps {
  translateStore?: ITranslateStore;
  invoicePaymentModalStore?: IInvoicePaymentModalStore;
  analyticsService?: AnalyticsService;
}

@inject('translateStore', 'invoicePaymentModalStore', 'analyticsService')
@observer
export default class InvoicePaymentModal extends React.Component<IInvoicePaymentModalProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const invoicePaymentModalStore = this.props.invoicePaymentModalStore;

    if (invoicePaymentModalStore.isModalLoading) {
      return null;
    }

    return (
      <PaymentModal
        amount={invoicePaymentModalStore.amount}
        headingLabel={translate('shared.payment-modal.bank-message')}
        referenceNumber={invoicePaymentModalStore.referenceNumber}
        onRedirectToBank={(banklinkName) => this.props.analyticsService.paymentModalPayInvoice(banklinkName)}
      />
    );
  }
}
